import { useMemo } from 'react';
import { Routes, Route, RouteProps } from 'react-router-dom';

import { useNavigationConfig } from '@/hooks';
import { BrowseEvents, EventDetail, NoMatch, PerformanceStudies } from '@/pages';

type RouteConfig = {
	main: React.ComponentType;
} & RouteProps;

export const Events = () => {
	const { navigationConfig } = useNavigationConfig();

	const routes: RouteConfig[] = useMemo(
		() => [
			...(navigationConfig?.allowBrowseEvents
				? [
						{
							path: '/browse-events',
							exact: true,
							main: BrowseEvents,
						},
						{
							path: '/browse-events/:eventId',
							exact: true,
							main: EventDetail,
						},
				  ]
				: []),
			...(navigationConfig?.allowPerformanceStudies
				? [
						{
							path: '/performance-studies',
							exact: true,
							main: PerformanceStudies,
						},
						{
							path: '/performance-studies/:eventId',
							exact: true,
							main: EventDetail,
						},
				  ]
				: []),
			{
				path: '/*',
				exact: false,
				main: NoMatch,
			},
		],
		[navigationConfig?.allowBrowseEvents, navigationConfig?.allowPerformanceStudies]
	);

	return (
		<Routes>
			{routes.map((route, index) => {
				return <Route key={index} path={route.path} element={<route.main />} />;
			})}
		</Routes>
	);
};
